// @flow
import * as React from 'react'
import cn from 'classnames'

import { Trans, withTranslation } from 'react-i18next'
import { Store } from 'Store'
import { Currency } from 'i18n/NumberFormatter'
import { makeDateFormatters } from 'i18n/DateFormat'

// import MainLogo from 'components/MainLogo'
import PromoVoucher from 'components/PromoVoucher'
import usePromoCode from 'util/hooks/usePromoCode'

import styles from './styles.module.scss'
import withTheme from 'hoc/withTheme'
import themes from './themes/__supportedThemes.js'

import transDomain from './translations/index.translations'

function PromoService (props) {
    const promoCode = usePromoCode()
    const { state, dispatch } = React.useContext(Store)
    const { t, theme } = props
    const currencyFormatter = Currency(state.currency, state.locale)

    React.useEffect(() => {
        if (props.match.params.locale) {
            dispatch({
                type: 'SET_LOCALE',
                payload: new Intl.Locale(props.match.params.locale),
            })
        }
    }, [dispatch, props.match.params.locale])

    const dateFormatter = React.useMemo(() => {
        return makeDateFormatters(state.locale, 'long', null)
    }, [state.locale])

    return (
        <div className={styles.container}>
            <div className={styles.topBar}>
                <div className={styles.topLogo} style={{
                    backgroundImage: `url(${theme.manufacturerLogo})`
                }} />
                <div className={styles.eventExpire} style={{
                    color: theme.topBarTextColor
                }}>
                    <Trans t={t} i18nKey="event_expire" values={{
                        expiryDate: dateFormatter.format(state.campaign.expiryDate, 'long')
                    }}>
                        This Exclusive Offering Ends <strong>{dateFormatter.format(state.campaign.expiryDate, 'long')}</strong>
                    </Trans>
                </div>
            </div>
            <div className={styles.topContainer}>
                <PromoVoucher width="100%" promoCode={promoCode}/>
            </div>

            <div className={styles.cars}>
                <img src={theme.cars} alt=""/>
            </div>

            <div className={styles.bottomContainer}>
                <h1 className={styles.title} style={{ color: theme.bottomTitleColor || theme.colors.primary }}>
                    <Trans t={t} i18nKey="title">
                        On Now! For Select Clients
                    </Trans>
                </h1>

                <p className={styles.description} style={{ color: theme.colors.ternary }}>
                    {t('description', {
                        expiry: dateFormatter.format(state.campaign.expiryDate, 'long'),
                        voucherName: state.campaign.incentives.voucher.name,
                        voucherValueRaw: state.campaign.incentives.voucher.value,
                        voucherValue: currencyFormatter.format(state.campaign.incentives.voucher.value),
                        voucherType: state.campaign.incentives.voucher.type
                    })}
                </p>

                <div className={styles.bottomRibbon} style={{ background: theme.colors.primary }}>
                    <div className={styles.bottomRibbonLabel}>{t('visit')}</div>
                    <div className={styles.bottomRibbonValue} style={{ color: theme.colors.secondary }}>{window.location.host}/{window.location.pathname.split('/')[1]}</div>
                    <div className={styles.bottomRibbonLabel}>{t('promo_code')}</div>
                    <div className={cn(styles.bottomRibbonValue, styles.bottomRibbonPromoCode)} style={{ color: theme.colors.secondary }}>{promoCode}</div>
                </div>

                <div className={styles.footerContainer}>
                    <div className={styles.footerDisclaimer} style={{ color: theme.colors.ternary }}>
                        {t('disclaimer')}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withTranslation(transDomain)(withTheme(themes)(PromoService))
